<ng-template #itemTemplate let-item>
    <span
        >{{ item.identifier }}
        <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container>
    </span>
    <span pTooltip="{{ 'common.thickness' | translate }}" *ngIf="item.thickness">
        ({{ item.thickness }})</span
    >
</ng-template>
<ng-template #selectedItemTemplate let-item>
    <span
        >{{ item.identifier }}
        <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container>
    </span>
    <span pTooltip="{{ 'common.thickness' | translate }}" *ngIf="item.thickness">
        ({{ item.thickness }})</span
    >
</ng-template>
